export default "__VITE_ASSET__vu$TL0zE__"